export enum TagType {
  BRAND = 'BRAND',
  CONDITION = 'CONDITION',
}
